import { defineComponent as _defineComponent } from 'vue'
import { onUnmounted, ref } from 'vue'
import { api } from "@/main";
import { AIMemory, AIMemoryType, AIPrincipal, Subscription } from "@/api";
import Card from "@/components/Card.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AIDashboard',
  props: ['aiId'],
  emits: ['breadcrumbs', 'menuItems'],
  setup(__props, { emit }) {

const props = __props




let memorySubscription: Subscription | null = null;

const ai = ref<AIPrincipal | null>(null);
const memories = ref<AIMemory[]>([]);
const messages = ref<AIMemory[]>([]);

api.ai.getAI(props.aiId).then(
  newAI => {
    ai.value = newAI;

    emit('menuItems', []);
    emit('breadcrumbs', [{
      text: ai.value.name,
      icon: '$smartHome',
      to: '/ai/' + props.aiId
    }]);

    if (memorySubscription != null)
      api.unsubscribe(memorySubscription);
    memorySubscription = api.ai.getAIMemories(props.aiId, (memory) => {
      if (memory.type === AIMemoryType.MEMORY) {
        let foundIndex = -1;
        memories.value.forEach((message, index) => {
          if (message.id === memory.id) {
            foundIndex = index;
            message.deletedTimestamp = memory.deletedTimestamp;
          }
        });

        if (foundIndex >= 0) {
          if (memory.deletedTimestamp)
            memories.value.splice(foundIndex, 1);
        } else {
          memories.value.unshift(memory);
        }
      } else {
        let found = false;
        messages.value.forEach(message => {
          if (message.id === memory.id) {
            found = true;
            message.deletedTimestamp = memory.deletedTimestamp;
          }
        })

        if (!found) {
          if (messages.value.length === 0 || Number(memory.id) < Number(messages.value[0].id)) {
            messages.value.unshift(memory);
          } else {
            messages.value.push(memory);
          }
        }

        while (messages.value.length > 20)
          messages.value.shift();
      }
    });
  }
)

onUnmounted(() => {
  if (memorySubscription != null)
    api.unsubscribe(memorySubscription);
})


return { __sfc: true,props, emit, memorySubscription, ai, memories, messages, api, AIMemoryType, Card }
}

})